import { render, staticRenderFns } from "./AppDescriptionTab.vue?vue&type=template&id=10fcea52&scoped=true"
import script from "./AppDescriptionTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDescriptionTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppDescriptionTab.vue?vue&type=style&index=0&id=10fcea52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fcea52",
  null
  
)

export default component.exports